<template>
  <div>
    <v-flex xs12>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn density="compact" :icon="true" v-on="on" @click="refreshNotCashOutBankAccounts"> <v-icon class="rounded-full text-l">refresh</v-icon></v-btn>
        </template>
        <span>{{i18n('Limpar cache e recarregar')}}</span>
      </v-tooltip>
      <ExternalBankAccounts
        :bank_accounts="bankAccounts.notCashOut"
        :subject_id="subject_id"
        :show_partner_external_bank_accounts="this.show_partner_external_bank_accounts"
        :show_external_bank_accounts="this.show_external_bank_accounts"
        :show_facilita_bank_accounts="this.show_facilita_bank_accounts"
        :show_admin_external_bank_account="this.show_admin_external_bank_account"
        :partner="isThisSubjectAPartner()"
        :subject_document_type="subject_document_type"
        @onAccountCreate="triggerInsertOneBankAccount"
        @onAccountDelete="triggerDeleteOneBankAccount"
        @onAccountUpdate="triggerUpdatedBankAccount"
        @onAccountClosed="triggerReloadUpdatedBankAccount"
        v-if="isNotCashOutBankAccountLoaded"
        :show_more_button="!bankAccounts.reachLimitNotCashOut"
        @requestMoreRecords="loadNotCashOutBankAccounts"
      />
    </v-flex>
    <v-flex row wrap xs12 mb-3 v-if="this.show_partner_facilita_bank_accounts">
      <h1 class="max">{{i18n('Contas FacilitaPay para pagamentos')}}
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon color="primary" dark v-on="on">help</v-icon>
          </template>
          <span>{{i18n('Contas Bancárias da FacilitaPay usadas para receber os pagamentos dos clientes')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn density="compact" :icon="true" v-on="on" @click="refreshFXBankAccounts"> <v-icon class="rounded-full text-l">refresh</v-icon></v-btn>
          </template>
          <span>{{i18n('Limpar cache e recarregar')}}</span>
        </v-tooltip>
      </h1>
    </v-flex>
    <v-flex xs12 v-if="this.show_partner_facilita_bank_accounts">
      <ExternalBankAccounts
        :bank_accounts="bankAccounts.facilita"
        :subject_id="subject_id"
        :show_partner_facilita_bank_accounts="show_partner_facilita_bank_accounts"
        :display_action_columns="false"
        :show_add_button=false
        :show_more_button="!bankAccounts.reachLimitFacilita"
        @requestMoreRecords="loadFacilitaBankAccounts"
      />
    </v-flex>
    <v-flex xs12 mb-3 v-if="hasNotCashOutInternalBankAccount">
      <h1 class="max">
        {{i18n('Contas Internas FacilitaPay')}}
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn density="compact" :icon="true" v-on="on" @click="refreshNotCashOutInternalBankAccounts"> <v-icon class="rounded-full text-l">refresh</v-icon></v-btn>
          </template>
          <span>{{i18n('Limpar cache e recarregar')}}</span>
        </v-tooltip>

      </h1>
    </v-flex>
    <v-flex xs12 v-if="hasNotCashOutInternalBankAccount">
      <InternalBankAccounts
      :bank_accounts="bankAccounts.notCashOutInternal"
      :show_branch_country="true"
      :show_more_button="!bankAccounts.reachLimitNotCashOutInternal"
      @requestMoreRecords="loadNotCashOutInternalBankAccounts"
      />
    </v-flex>
    <v-flex xs12 mb-3 v-if="hasCashOutInternalBankAccount">
      <h1 class="max">
        {{i18n('Contas de Taxas Operacionais')}}
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon color="primary" dark v-on="on">help</v-icon>
          </template>
          <span>{{i18n('Contêm a soma das taxas referentes às operações já feitas')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn density="compact"  v-on="on" :icon="true" @click="refreshCashOutInternalBankAccounts"> <v-icon class="rounded-full text-l">refresh</v-icon></v-btn>
          </template>
          <span>{{i18n('Limpar cache e recarregar')}}</span>
        </v-tooltip>
      </h1>
    </v-flex>
    <v-flex xs12 v-if="hasCashOutInternalBankAccount">
      <InternalBankAccounts
      :bank_accounts="bankAccounts.cashOutInternal"
      :show_more_button="!bankAccounts.reachLimitCashOutInternal"
      @requestMoreRecords="loadCashOutBankAccounts"
      />
    </v-flex>
  </div>
</template>

<script>

import ExternalBankAccounts from "../ExternalBankAccounts"
import InternalBankAccounts from "../InternalBankAccounts"
import { BankAccountsApi } from '@/shared/BankAccountsApi'

export default {
  name: 'BankAccounts',
  components: {
    ExternalBankAccounts,
    InternalBankAccounts,
  },
  props: {
    subject_id: {
      type: String
    },
    wait_for_subject: {
      type: Boolean,
      default: false
    },
    show_partner_facilita_bank_accounts: {
      type: Boolean,
      default: false
    },
    show_partner_external_bank_accounts: {
      type: Boolean,
      default: false
    },
    show_external_bank_accounts: {
      type: Boolean,
      default: false
    },
    show_facilita_bank_accounts: {
      type: Boolean,
      default: false
    },
    show_admin_external_bank_account: {
      type: Boolean,
      default: false
    },
    subject_document_type: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      errors: {},
      admin: false,
      mode: 'insert',
      targetUrl: '',
      accounts_list: [],
      liability_accounts: [],
      fetched_complete: false,
      fx_partner_accounts_list: [],
      loaded_bank_accounts_last_id: null,
      // NOTE1: We use bankAccounts as object to enable reactivity when use $set. (ex.: this.$set(this.bankAccounts, 'cashOut', [...]) )
      bankAccounts : {
        notCashOut: [],
        cashOut: [],
        cashOutInternal: [],
        notCashOutInternal: [],
        facilita: [],
        reachLimitCashOut: true,
        reachLimitNotCashOut: true,
        reachLimitFacilita: true,
        reachLimitCashOutInternal: true,
        reachLimitNotCashOutInternal: true,
        notCashOutLoadedAt: 0,
        cashOutLoadedAt: 0,
        notCashOutInternalLoadedAt: 0,
        cashOutInternalLoadedAt: 0,
        facilitaLoadedAt: 0,

      }
    }
  },
  computed: {
    isNotCashOutInternalLoaded(){
      return this.bankAccounts.notCashOutInternalLoadedAt > 0;
    },
    isCashOutInternalLoaded(){
      return this.bankAccounts.cashOutInternalLoadedAt > 0;
    },
    isNotCashOutBankAccountLoaded(){
      return this.bankAccounts.notCashOutLoadedAt > 0;
    },
    isCashOutBankAccountLoaded(){
      return this.bankAccounts.cashOutLoadedAt > 0;
    },
    isFacilitaBankAccountLoaded(){
      return this.bankAccounts.facilitaLoadedAt > 0;
    },
    hasCashOutInternalBankAccount(){
      return this.bankAccounts.cashOutInternal.length > 0;
    },
    hasNotCashOutInternalBankAccount(){
      return this.bankAccounts.notCashOutInternal.length > 0;
    },
    inserting_subject() {
      if (this.subject_id === '') return true
      return false
    },
    is_subject() {
      if (this.subject_id === '') return true
      return !!this.subject_id
    },
    fx_url() {
      if(this.admin && this.subject_id) {
        return this.$root.urls.admin__fx_bank_accounts_by_partner_id.replace('ID', this.subject_id)
      } else {
        return this.$root.urls.fx_bank_accounts;
      }
    },
    bank_accounts_url() {
      if(!!this.subject_id && !!this.admin) {
        return this.$root.urls.admin__bank_accounts.split('ID').join(this.subject_id)
      } else if(!!this.subject_id) {
        return this.$root.urls.customer__subject__bank_accounts.split('ID').join(this.subject_id)
      } else{
        return this.$root.urls.bank_accounts
      }
    }
  },

  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    trigger_refresh() {
      this.refreshNotCashOutBankAccounts();
      this.refreshNotCashOutInternalBankAccounts();
      this.refreshCashOutInternalBankAccounts();
      this.refreshFXBankAccounts();
    },
    triggerUpdatedBankAccount(bank_account) {
      if(bank_account && bank_account.id != undefined) {
        BankAccountsApi.updateOneBankAccount(this, 'notCashOut', bank_account);
      }
    },
    triggerReloadUpdatedBankAccount(bank_account, force_reload = false) {
      if(force_reload && bank_account && bank_account.id != undefined) {
        BankAccountsApi.reloadOneBankAccount(this,'notCashOut', bank_account);
      }
    },
    triggerInsertOneBankAccount(bank_account) {
      if(bank_account && bank_account.id != undefined) {
        BankAccountsApi.insertOneBankAccount(this,'notCashOut', bank_account);
      }
    },
    triggerDeleteOneBankAccount(bank_account) {
      if(bank_account && bank_account.id != undefined) {
        BankAccountsApi.deleteOneBankAccount(this,'notCashOut', bank_account);
      }
    },
    loadCashOutInternalBankAccounts() {
      BankAccountsApi.loadBankAccountIntoField(this, 'cashOutInternal', this.bank_accounts_url, {
        filter: "cash_out_internal"
      }, {show_facilita_bank_accounts: this.show_facilita_bank_accounts})
    },
    loadNotCashOutInternalBankAccounts() {
      BankAccountsApi.loadBankAccountIntoField(this, 'notCashOutInternal', this.bank_accounts_url, {
        filter: "not_cash_out_internal"
        }, {show_facilita_bank_accounts: this.show_facilita_bank_accounts})
    },
    loadCashOutBankAccounts() {
      BankAccountsApi.loadBankAccountIntoField(this, 'cashOut', this.bank_accounts_url, {filter: "cash_out"}, {show_facilita_bank_accounts: this.show_facilita_bank_accounts})
    },
    loadNotCashOutBankAccounts() {
      BankAccountsApi.loadBankAccountIntoField(this, 'notCashOut', this.bank_accounts_url, {filter: "not_cash_out"}, {show_facilita_bank_accounts: this.show_facilita_bank_accounts})
    },
    loadFacilitaBankAccounts() {
      BankAccountsApi.loadBankAccountIntoField(this, 'facilita', this.fx_url, {}, {show_facilita_bank_accounts: this.show_facilita_bank_accounts, is_facilita_bank_account: true})
    },
    refreshNotCashOutBankAccounts() {
      this.bankAccounts.notCashOut = [];
      this.bankAccounts.notCashOutLoaded = false;
      this.bankAccounts.notCashOutLoadedAt = 0;
      this.bankAccounts.reachLimitCashOut = false;
      this.loadNotCashOutBankAccounts()
    },
    refreshNotCashOutInternalBankAccounts() {
      this.bankAccounts.notCashOutInternal = [];
      this.bankAccounts.notCashOutInternalLoaded = false;
      this.bankAccounts.notCashOutInternalLoadedAt = 0;
      this.bankAccounts.reachLimitNotCashOutInternal = false;
      this.loadNotCashOutInternalBankAccounts()
    },
    refreshCashOutInternalBankAccounts() {
      this.bankAccounts.cashOutInternal = [];
      this.bankAccounts.cashOutInternalLoaded = false;
      this.bankAccounts.cashOutInternalLoadedAt = 0;
      this.bankAccounts.reachLimitCashOutInternal = false;
      this.loadCashOutInternalBankAccounts()
    },
    refreshFXBankAccounts() {
      this.bankAccounts.facilita = [];
      this.bankAccounts.facilitaLoaded = false;
      this.bankAccounts.facilitaLoadedAt = 0;
      this.bankAccounts.reachLimitFacilita = false;
      this.loadFacilitaBankAccounts();
    },

    isThisSubjectAPartner() {
      if (this.has_internal_bank_accounts) {
        return true
      } else {
        return false
      }
    }
  },

  watch: {
    subject_id(new_val, old_val) {
      if (old_val !== new_val) {
        this.trigger_refresh()
      }
    }
  },

  mounted() {
    this.admin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'
    if(!this.wait_for_subject || !!this.subject_id) {
      this.trigger_refresh();
    }

    this.$root.$on('reload-accounts', () => {
      this.trigger_refresh()
    })
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/BankAccounts.vue